<aslib-title Text="Consulta/Saldo Devedor do Município" SubText="Consultar" Icon="fa fa-dollar"></aslib-title>
<form novalidate [formGroup]='formSaldoDevedor'>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Período:<span>*</span></label>
    <div class="controls col-md-2">
      <input type="date" [(ngModel)]="DataInicio"  formControlName="DataInicio" class="form-control"  (change)="limparConsulta()">
    </div>
    <div> e </div>
    <div class="controls col-md-2">
      <input  type="date"  [(ngModel)]="DataFim"  formControlName="DataFim" class="form-control"  (change)="limparConsulta()">
    </div>
  </div>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Município:</label>
    <div class="controls col-md-4">
      <select [(ngModel)]="municipioSelected"  formControlName="Municipio" class="form-control" (change)="limparConsulta()">
        <option [ngValue]=undefined>Todos</option>
        <option *ngFor="let municipio of listaMunicipio" [ngValue]= "municipio">{{municipio.Descricao}}</option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <div class="controls col-md-9 offset-md-3">
      <button type="submit" class="btn btn-primary" [disabled]="!formSaldoDevedor.valid" (click)="consultarSaldoDevedorMunicipio(modalMensagem)" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Aplicar Filtro
      </button>
    </div>
  </div>

  <div class="form-group row mb-5" *ngIf="exibirGrid">
    <aslib-grid id="as-grid" class="col-md-12" [(dataset)]="saldoDevedorMunicipioModelView.ListaSaldoDevedorMunicipio" [pagination]="true">
      <aslib-grid-column [property]="'DataInclusao'" [header]="'Data de Inclusão'" [width]="300" [sortable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{ item.DataInclusao | date : 'dd/MM/yyyy' }}</span>
        </ng-template>
      </aslib-grid-column>
      <aslib-grid-column [property]="'DescricaoMunicipio'" [header]="'Município'" [width]="300" [sortable]="true"></aslib-grid-column>
      <aslib-grid-column [property]="'ValorDevido'"  [width]="200" [header]="'Valor Devido'"  [sortable]="true">
        <ng-template #AslibGridCell let-item="item">
          <span>{{ item.ValorDevido | currency : 'R$' }}</span>
        </ng-template>
     </aslib-grid-column>
    </aslib-grid>
  </div>

<div class="form-group row"  *ngIf="exibirGrid">
  <div class="col-md-12">
    <button type="submit" class="btn btn-primary" (click)="gerarRelatorio(0)" [disabled]="!formSaldoDevedor.valid">
      <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Pdf
    </button>
 
    <button type="submit" class="btn btn-primary" (click)="gerarRelatorio(1)" [disabled]="!formSaldoDevedor.valid">
      <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Excel
    </button>
  </div>
</div>

</form>
<aslib-modal #modalMensagem></aslib-modal>



// WEBPACK FOOTER //
// ./src/app/consulta/saldo-devedor-municipio/saldo-devedor-municipio.component.html